import { Size } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Hoverable, { HoverEventListener } from '@philips-emr/tws-core/lib/component/types/hoverable';
import { isEnumValid } from '@philips-emr/tws-utils';

class LinkAPI extends ComponentAPI implements Clickable, Hoverable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onMouseEnter = new HoverEventListener();

  /** @event */
  @AwesomeEvent
  onMouseMove = new HoverEventListener();

  /** @event */
  @AwesomeEvent
  onMouseLeave = new HoverEventListener();

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  getSize(): Size {
    return this.state.size;
  }

  setSize(size: Size): void {
    if (isEnumValid(Size, size)) {
      this.setState({ size });
    }
  }

  setBadge(badge: string | null): void {
    this.setState({ badge });
  }

  getBadge(): string | null {
    return this.state.badge;
  }

  isPreventDefault(): boolean {
    return this.state.preventDefault;
  }

  setPreventDefault(preventDefault: boolean): void {
    this.setState({ preventDefault });
  }

  isStopPropagation(): boolean {
    return this.state.stopPropagation;
  }

  setStopPropagation(stopPropagation: boolean): void {
    this.setState({ stopPropagation });
  }

  setIcon(icon: string | null): void {
    this.setState({ icon });
  }

  getIcon(): string | null {
    return this.state.icon;
  }
}

export default LinkAPI;
